import React, { useContext, useState } from 'react';
import { Link } from 'react-router-dom';
import { FooterStyles } from './Layout.style';
import { AuthContext } from 'router/AuthProvider';

import { ReactComponent as Home } from 'assert/images/Navbar/home.svg';
import { ReactComponent as Network } from 'assert/images/Navbar/network.svg';
import { ReactComponent as Work } from 'assert/images/Navbar/work.svg';
import { ReactComponent as Assistant } from 'assert/images/Navbar/assistant.svg';
import { ReactComponent as More } from 'assert/images/Navbar/menu.svg';

import { ReactComponent as HomeFilled } from 'assert/images/Navbar/homeFilled.svg';
import { ReactComponent as WorkFilled } from 'assert/images/Navbar/workFilled.svg';
import { ReactComponent as AssistantFilled } from 'assert/images/Navbar/assistantFilled.svg';
import { ReactComponent as NetworkFilled } from 'assert/images/Navbar/networkFilled.svg';

import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import LoginNotification from 'pages/auth/LoginNotification';

export default function Footer() {
  const { t } = useTranslation();
  const { isLoggedIn } = useContext(AuthContext);
  const [isLoginNotificationOpen, setIsLoginNotificationOpen] = useState(false);

  const MenuList = [
    {
      icon: <Home />,
      filledIcon: <HomeFilled />,
      title: t('HomePage.Home'),
      path: '/',
      activePath: ['/post-history', '/post-details', '/following'],
      exactPath: ['/'],
    },
    {
      icon: <Work />,
      filledIcon: <WorkFilled />,
      title: t('HomePage.Job'),
      path: '/jobs',
      activePath: ['/postjob'],
      exactPath: ['/jobs'],
    },
    {
      icon: <Assistant />,
      filledIcon: <AssistantFilled />,
      title: 'Business',
      path: '/business-hub',
      activePath: ['/business-hub'],
    },
    {
      icon: <Network />,
      filledIcon: <NetworkFilled />,
      title: t('HomePage.Network'),
      path: '/network/suggestions',
      activePath: ['/network'],
    },

    {
      icon: <More />,
      filledIcon: <More />,
      title: t('HomePage.More'),
      path: '/more',
      activePath: ['/more'],
    },
  ];

  const windowLocation = window.location.pathname;
  return (
    <FooterStyles>
      <div className="footer-default-height" />
      <div
        className={clsx(
          'footer-container',
          !isLoggedIn && 'footer-align-evenly'
        )}
      >
        {(isLoggedIn
          ? MenuList
          : MenuList.filter((_, index) => index !== 3)
        ).map((data, index) => {
          const isPathInclude = data.activePath.find((path) =>
            windowLocation.startsWith(path)
          );
          const isExactPath = data.exactPath?.find(
            (path) => windowLocation === path
          );
          return (
            <Link
              key={index}
              to={(!isLoggedIn && index === 3) ? '#' : data.path}
              onClick={(e) => {
                if (!isLoggedIn && index === 3) {
                  e.preventDefault();
                  setIsLoginNotificationOpen(true);
                }
              }}
              className={clsx(
                'icon-div',
                (isPathInclude || isExactPath) && 'active-fot',
                index === 0 && 'active-home'
              )}
            >
              <div>
                {isPathInclude || isExactPath ? data.filledIcon : data.icon}
              </div>
              <label>{data.title}</label>
            </Link>
          );
        })}
      </div>
      <LoginNotification
        isLoginNotificationOpen={isLoginNotificationOpen}
        handleUpdateModal={() => setIsLoginNotificationOpen(false)}
      />
    </FooterStyles>
  );
}
